import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
import Typography from "@mui/material/Typography";
import { Controller } from "react-hook-form";
import styled from "@emotion/styled";

const ReactHookFormSelect = ({
  name,
  label,
  control,
  defaultValue,
  children,
  errors,
  fields,
  onChangeEvent,
  ...props
}) => {
  const isFieldRequired = () => {
    try {
      const parts = name.split(".");

      if (parts.length == 3) {
        console.log(errors[parts[0]], Number(parts[1]), "klklkll");
        return errors[parts[0]][Number(parts[1])][parts[2]] == undefined ? false : true;
      }
      if (parts.length == 1) {
        return errors?.[parts[0]] == undefined ? false : true;
      }

      return false;
    } catch (e) {
      console.log(e, "klklkll");
      return false;
    }
  };
  const required1 = isFieldRequired();
  console.log(name, required1, "yumschema");
  const labelId = `${name}-label`;
  const required = fields?.[name]
    ? !!fields[name]?.exclusiveTests?.required || fields[name]?.spec?.optional === false
    : false;
  console.log(name, errors, "requiredrequiredrequired");
  return (
    <FormControl {...props}>
      <InputLabel id={labelId} error={required1} required={required}>
        {label}
      </InputLabel>
      <Controller
        render={({ field }) => (
          <Select
            {...field}
            labelId={labelId}
            id={labelId}
            label={label}
            error={required1}
            value={field.value ? field.value : ""}
            onChange={(e) => {
              console.log(field, "field");
              field.onChange(e); // Update form state
              if (onChangeEvent) onChangeEvent(e); // Call additional event if provided
            }}
          >
            {children}
          </Select>
        )}
        name={name}
        control={control}
      />
      <FormHelperText sx={{ color: "#d32f2f" }}>{errors[name]?.message}</FormHelperText>
    </FormControl>
  );
};
export default ReactHookFormSelect;
